import React, { useEffect } from 'react';
import { useGlobalStore } from '@/stores/globalStore';
import { SettingsNavigation } from '@/features/settings/components/SettingsNavigation';

const SettingsPage: React.FC = () => {
    const setBreadcrumbs = useGlobalStore(state => state.setBreadcrumbs);

    // Set breadcrumbs
    useEffect(() => {
        setBreadcrumbs([{ title: 'My Account Settings', to: '/account_settings', active: true, id: 'settings' }]);
    }, [setBreadcrumbs]);

    return <SettingsNavigation />;
};

export default SettingsPage;
